<template>
  <div>
    <!-- 통합 주소 찾기 -->
    <header
      id="header"
      v-if="$route.name != 'Login' && $route.name != 'AdminLogin'"
      class="HideOnPrint"
      :style="{ zIndex: isMobile ? '10' : '10000' }"
    >
      <!-- 좌측 네비 -->
      <div class="navi" v-if="!isMobile">
        <strong><a @click.stop="moveToMenu('Map')">WOOMI GIS</a></strong>

        <ul class="link-tabs">
          <li :class="{ active: menu == 'Map' }">
            <a @click.stop.prevent="moveToMenu('Map')">
              <span><i class="fa fa-location-arrow"></i>입지분석</span>
            </a>
          </li>
          <li :class="{ active: menu == 'Statistics' }">
            <a @click.stop.prevent="moveToMenu('Statistics')">
              <span><i class="fa fa-bar-chart"></i>통계</span>
            </a>
          </li>

          <li :class="{ active: menu == 'Reference' }">
            <a @click.stop.prevent="moveToMenu('Reference')">
              <span><i class="fa fa-folder"></i>자료실</span>
            </a>
          </li>
          <li :class="{ active: menu == 'Mypage' }">
            <a @click.stop.prevent="moveToMenu('Mypage')">
              <span><i class="fa fa-user"></i>마이페이지</span>
            </a>
          </li>
          <li :class="{ active: menu == 'Admin' }">
            <a @click.stop.prevent="moveToMenu('Admin')">
              <span><i class="fa fa-gear"></i>관리자</span>
            </a>
          </li>
        </ul>
        <div class="UpbandZoom">
          <div class="ZoomLv">
            <span>Zoom : {{ zoom.toFixed(2) }} / {{ scale }}</span>
          </div>

          <div class="UpBtnBox">
            <!-- <a v-if="user.erp_info"
              ><i class="fa fa-address-card color"></i
              ><strong>{{ user.erp_info.department }}<span></span></strong
            ></a> -->
            <a
              ><strong>{{ user.first_name }}<span>님</span></strong></a
            >
            <a @click="signOut()"><i class="fa fa-power-off"></i></a>
          </div>
        </div>
      </div>
      <div v-if="isMobile">
        <div class="UpbandZoom">
          <div class="mobile-menu-zoom">
            <span>Zoom : {{ zoom.toFixed(2) }} / {{ scale }}</span>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "TopMenu",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      zoom: "getZoom",
      scale: "getScale",
      menu: "getMenu",
      user: "getUser",
    }),
    isMobile() {
      return this.$funcs.isMobile();
    },
  },
  methods: {
    ...mapActions(["signOut"]),
    ...mapMutations({
      setMenu: "SET_MENU",
    }),
    moveToMenu(tab) {
      this.setMenu(tab);
      this.$router.push({ name: tab });
    },
  },
};
</script>

<style scoped>
.mobile-menu-zoom {
  position: fixed;
  height: 34px;
  line-height: 35px;
  font-size: 12px;
  top: 10px;
  right: 10px;
  background-color: #fff;
  border-right: 1px solid #e3e3e3;
  padding: 0px 5px 0px 5px;
  border-radius: 3px;
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.15);
  z-index: 10000;
}
</style>
